import React from 'react';
import { BackTop } from 'antd';
import classnames from 'classnames/bind';
import IconBackTop from '@/assets/svg/icon-back-top.svg';

import { BASIC_LAYOUT_ID } from '@/constants';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export const Back2Top = () => {
  return (
    <BackTop target={() => document.getElementById(BASIC_LAYOUT_ID) || document}>
      <div className={cx('back-top-wrapper')}>
        <img src={IconBackTop} alt="icon" />
      </div>
    </BackTop>
  );
};
export default Back2Top;
